import { Reducer } from 'redux';
import { reducer as simpleFormReducer, INITIAL_SIMPLEFORM_STATE } from 'app/infrastructure/simple-form/reducers';
import { MyDownloadsState } from './types-store';
import { reducers as exportsView } from './exports/exports-view/reducers';
import { reducers as reportsView } from './reports-view/reducers';
import { reducers as exportToZipModal } from './exports/export-to-zip-modal/reducers';
import { STATE } from 'app/constants';
import { INITIAL_EXPORTS_VIEW_STATE } from 'app/area/my-downloads/exports/exports-view/reducers';
import { INITIAL_EXPORTS_MODAL_STATE } from 'app/area/my-downloads/exports/export-to-zip-modal/reducers';
import { INITIAL_REPORTS_VIEW_STATE } from 'app/area/my-downloads/reports-view/reducers';

const INITIAL_EXPORTS_STATE: MyDownloadsState = {
  ...INITIAL_EXPORTS_VIEW_STATE,
  ...INITIAL_EXPORTS_MODAL_STATE,
  ...INITIAL_REPORTS_VIEW_STATE,

  texts: {},
  validation: {},
  ...INITIAL_SIMPLEFORM_STATE
};

export const reducer: Reducer<MyDownloadsState> = (state: MyDownloadsState = INITIAL_EXPORTS_STATE, action: any) => {

  const allExportsReducers = {
    ...exportsView,
    ...exportToZipModal,
    ...reportsView
  };

  const r: any = allExportsReducers[action.type];

  return (r && r(state, action)) || simpleFormReducer(STATE.myDownloads)(state, action);
};
